import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import CardUI from '../../../widgets/layout/CardUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import { emptyString } from 'react-select-v2/lib/utils'
const PartnerAccountUpdateModalUI = ({ context, successMsg, errorList, setErrorList, accountList,
    // modes
    updateMode, submitted, onGuarantorUpdateClick, guarantorName, coBorrowerName,
    // event handlers
    onSubmit, onCancelClick, partnerTypeList,
    // form fields
    partnerType, onPartnerTypeChange, partnerTypeError, setPartnerTypeError,
    partnerAccountId, onPartnerAccountIdChange, partnerAccountIdError, setPartnerAccountIdError,
}) =>
    <CardUI title='Co-Borrower / Guarantor Account' noUnderline={true}>
        <div className='g_flex_h g_m_left_100 g_flex_top g_flex_right'>
            <span className='g_flex_v g_flex_left'>Co-Borrower / Guarantor Account</span>
            {/* {
                guarantorName !== emptyString || coBorrowerName !== emptyString &&
                <span className='wrap'>{"Guarantor :"}{guarantorName}, {"Co-Borrower : "}{coBorrowerName}</span>
            } */}
            <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onGuarantorUpdateClick} />
        </div>

        <UpdateModal context={context} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
            accountList={accountList} updateMode={updateMode} submitted={submitted} onSubmit={onSubmit} onCancelClick={onCancelClick}
            partnerTypeList={partnerTypeList} partnerType={partnerType} onPartnerTypeChange={onPartnerTypeChange} onPartnerAccountIdChange={onPartnerAccountIdChange}
            partnerTypeError={partnerTypeError} setPartnerTypeError={setPartnerTypeError} partnerAccountId={partnerAccountId} partnerAccountIdError={partnerAccountIdError}
            setPartnerAccountIdError={setPartnerAccountIdError}
        />

    </CardUI>

const UpdateModal = ({ context, successMsg, errorList, setErrorList, accountList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick, partnerTypeList,
    // form fields
    partnerType, onPartnerTypeChange, partnerTypeError, setPartnerTypeError,
    partnerAccountId, onPartnerAccountIdChange, partnerAccountIdError, setPartnerAccountIdError, }) =>
    <ModalFormUI
        context={context}
        titleLabel='Update Partner'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputSelectSF type='select' name='partnerType' label='Co-Borrower / Guarantor Type'
            value={partnerType} onChange={onPartnerTypeChange} optionList={partnerTypeList}
            error={partnerTypeError} setError={setPartnerTypeError}
        />

        {
            partnerType !== emptyString &&
            <InputSelectSF type='select' name='PartnerAccountId' label={partnerType === 'co-borrower' ? 'Co-Borrower Account' : 'Guarantor Account'}
                value={partnerAccountId} onChange={onPartnerAccountIdChange} optionList={accountList}
                error={partnerAccountIdError} setError={setPartnerAccountIdError}
            />
        }
    </ModalFormUI>

export default PartnerAccountUpdateModalUI
